import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { getStatus } from '../chaos-table.component';
import { ChaosTableService } from '../chaos-table.service';
import { ChaosTableRow } from '../types/chaos-table-row.interface';
import { PossibleRowDuplicate } from '../types/chaos-table.dto';

@Component({
   selector: 'app-join-rows-dialog',
   templateUrl: './join-rows-dialog.component.html',
   styleUrls: ['./join-rows-dialog.component.css']
})
export class JoinRowsDialogComponent implements OnInit {
   source: number | undefined;

   target: number | undefined;

   dataSource = new MatTableDataSource<PossibleRowDuplicate>();

   headerRow = ['id', 'name', 'birthDate', 'studentStatus'];

   sourceDisabled = false;

   targetDisabled = true;

   constructor(
      public dialogRef: MatDialogRef<JoinRowsDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public selectedRow: ChaosTableRow,
      private chaosTableService: ChaosTableService,
      private snackBar: MatSnackBar
   ) {}

   ngOnInit(): void {
      this.loadData();
      this.target = this.selectedRow.id;
   }

   loadData() {
      this.chaosTableService
         .listPossibleRowDuplicates({ id: this.selectedRow.id })
         .subscribe(res => {
            this.dataSource.data = res;
         });
   }

   onRowClicked(id: number) {
      if (!this.sourceDisabled) {
         this.source = id;
      } else {
         this.target = id;
      }
   }

   onJoinClicked(): void {
      if (this.source && this.source > 0 && this.target && this.target > 0) {
         this.chaosTableService
            .joinRows({ source: this.source, target: this.target })
            .subscribe(() => {
               this.snackBar.open(`Az összerendelés sikeresen megtörtént!`, 'Ok', {
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  duration: 5000
               });
               this.dialogRef.close(true);
            });
      }
   }

   swapSourceAndTarget(): void {
      const oldSource = this.source;
      this.source = this.target;
      this.target = oldSource;
      this.sourceDisabled = !this.sourceDisabled;
      this.targetDisabled = !this.targetDisabled;
   }

   getStatus = getStatus;
}
